import type { FaireProductEntity } from "../../entity_types/product";

export const p_6e3p4fjpuv: FaireProductEntity = {
  token: "p_6e3p4fjpuv",
  type: "product",
  name: "Ruby-throated Hummingbird Enamel Pin",
  brandToken: "b_6i5zv0objg",
  brandName: "Bird Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/01d5403736c9cfbd3d09cc61e74839da08010c0b04b956ea29334c20e0922767.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab59c7dccf4e04268ac3e0c28dc547cc0a2e98906259cc00f9b58f368dd29117.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Bold and brilliant, Ruby-throated Hummingbirds are eastern North America’s only breeding hummingbird, a dazzling sight of red and green as they buzz around flower gardens or backyard feeders in search of nectar. These tiny birds will migrate across the Gulf of Mexico in a single flight, beating their wings about 53 times a second. Most spend winters in Central America.\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:24.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
